import React, { useEffect, useState } from 'react'
import { getGoodTypesAllAPI } from '../../../api/products/goodTypeAPI'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getExpenseTypesAllAPI } from '../../../api/expense/expenseTypeAPI'

const ExpenseTypeSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [expenseTypes, setExpenseTypes] = useState([])

	useEffect(() => {
		getGoodTypes()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getGoodTypes = () => {
		getExpenseTypesAllAPI().then(data => {
			setExpenseTypes(data)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Тип витрат"
        labelId="select__expenseType-label"
        id='select__expenseType'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Тип витрат'
        // sx={{width: '200px'}}
        options={
			expenseTypes && expenseTypes.length > 0 ? 
				expenseTypes.map(expenseType => {
            		return {id: expenseType.id, name: expenseType.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default ExpenseTypeSelectMain